import { PropsWithChildren } from "react";

import { useStore } from "@/hooks/store";

import styles from "./styles";

export const Layout: React.FC<PropsWithChildren> = ({ children }): JSX.Element => {
  const hasNFT = useStore((store) => {
    const currentNetworkData = store.user.networksData[store.network];
    return Boolean(currentNetworkData?.nft?.array.length || currentNetworkData?.nft?.isPurchased);
  });

  return (
    <styles.LayoutWrapper>
      <styles.Main>
        <styles.Background $hasNFT={hasNFT} />
        {children}
      </styles.Main>
    </styles.LayoutWrapper>
  );
};
